(function () {
  let locRootCounter = 0;

  function getRootId(root) {
    if (!root.dataset.locRootId) {
      locRootCounter += 1;
      root.dataset.locRootId = String(locRootCounter);
    }
    return root.dataset.locRootId;
  }

  function getPortalHost(root) {
    const rootId = getRootId(root);

    if (root.__locPortalHost && document.body.contains(root.__locPortalHost)) {
      return root.__locPortalHost;
    }

    let host = document.querySelector('.header-localization__portal[data-loc-root-id="' + rootId + '"]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'header-localization__portal';
      host.dataset.locRootId = rootId;
      document.body.appendChild(host);
    }

    root.__locPortalHost = host;
    return host;
  }

  function attachToPortal(root) {
    const host = getPortalHost(root);
    const overlay = root.querySelector('.header-localization__overlay');
    const panel = root.querySelector('.header-localization__panel');

    if (overlay && overlay.parentElement !== host) host.appendChild(overlay);
    if (panel && panel.parentElement !== host) host.appendChild(panel);

    return {
      overlay: overlay || host.querySelector('.header-localization__overlay'),
      panel: panel || host.querySelector('.header-localization__panel'),
    };
  }

  function setLayerOpen(root, isOpen) {
    const toggle = root.querySelector('.header-localization__toggle');
    const host = root.__locPortalHost;
    const overlay = host?.querySelector('.header-localization__overlay');
    const panel = host?.querySelector('.header-localization__panel');

    root.classList.toggle('is-open', isOpen);
    if (overlay) overlay.classList.toggle('is-open', isOpen);
    if (panel) panel.classList.toggle('is-open', isOpen);
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function syncBodyState() {
    const anyOpen = document.querySelector('.header-localization.is-open');
    document.body.classList.toggle('localization-drawer-open', Boolean(anyOpen));

    if (!anyOpen && !window.Shopify?.designMode) {
      document.body.style.overflow = '';
    }
  }

  function closeDrawer(root) {
    setLayerOpen(root, false);
    syncBodyState();
    document.dispatchEvent(new CustomEvent('localization-drawer:closed', { detail: { root } }));
  }

  function openDrawer(root) {
    document.querySelectorAll('.header-localization.is-open').forEach(function (other) {
      if (other !== root) closeDrawer(other);
    });

    attachToPortal(root);
    setLayerOpen(root, true);
    syncBodyState();

    if (!window.Shopify?.designMode) {
      document.body.style.overflow = 'hidden';
    }

    document.dispatchEvent(new CustomEvent('localization-drawer:opened', { detail: { root } }));
  }

  function init(root) {
    if (root.dataset.locInit === 'true') return;
    root.dataset.locInit = 'true';

    const toggle = root.querySelector('.header-localization__toggle');
    const panel = root.querySelector('.header-localization__panel');
    const overlay = root.querySelector('.header-localization__overlay');
    const form = panel?.querySelector('form');
    const countryInput = form?.querySelector('input[name="country_code"]');
    const languageInput = form?.querySelector('input[name="language_code"]');

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (root.classList.contains('is-open')) {
          closeDrawer(root);
        } else {
          openDrawer(root);
        }
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeDrawer(root);
      });
    }

    if (panel) {
      const closeBtn = panel.querySelector('.header-localization__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeDrawer(root);
        });
      }

      panel.querySelectorAll('.header-localization__lang').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!form || !countryInput || !languageInput) return;
          countryInput.value = btn.getAttribute('data-country');
          languageInput.value = btn.getAttribute('data-language');
          form.submit();
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-localization-drawer]').forEach(init);
  }

  if (!window.__headerLocalizationKeydown) {
    window.__headerLocalizationKeydown = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.header-localization.is-open').forEach(closeDrawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
